<template>
    <div>
        <v-navigation-drawer
            v-model="initializeProjectDialog"
            temporary
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card tile class="drawer-content pb-12">
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                        Initialize this Project
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            @click="handleCancelAddModuleDialogs">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>

                <v-card-text class="mt-12">
                    <div class="d-block">
                        <v-autocomplete
                            v-model="add_module"
                            label="Select a module to add"
                            :items="assignableModules"
                            item-text="module_name_text"
                            return-object
                            color="primary"
                            outlined
                            @change="getEmailTemplate">
                        </v-autocomplete>
                    </div>
                </v-card-text>

                <v-card-text v-if="add_module.hasOwnProperty('module_key')">
                    <div class="d-block">
                        Who is the SRG Sales Representative responsible for this project?<br>
                        <v-autocomplete
                            v-model="srg_sales_representatives"
                            :items="srgSalesRepresentatives"
                            item-text="name"
                            return-object
                            label="SRG Sales Representative"
                            :error="showRequiredFieldErrors && !hasValidSalesRepresentativeSelection()"
                            :error-messages="showRequiredFieldErrors && !hasValidSalesRepresentativeSelection() ? ['SRG Sales Representative is required.'] : []"
                            outlined
                            class="mt-4"
                        ></v-autocomplete>
                    </div>
                </v-card-text>

                <v-card-text v-if="add_module.hasOwnProperty('module_key') && add_module.module_key != 'enterprise-consulting'">
                    <div class="d-block mb-4">
                        Who will be the lead PM on this project?<br>
                        <v-autocomplete
                            v-model="srg_project_managers"
                            :items="availableProjectManagers"
                            item-text="name"
                            return-object
                            label="SRG Project Managers"
                            :error="showRequiredFieldErrors && !hasValidProjectManagerSelection()"
                            :error-messages="showRequiredFieldErrors && !hasValidProjectManagerSelection() ? ['SRG Project Manager is required.'] : []"
                            outlined
                            @change="handleProjectManagerSelectionChange"
                            class="mt-4"
                        ></v-autocomplete>
                    </div>

                    <div class="d-block my-4">
                        If a change is necessary, please select all PCs who will be involved on this project.<br>
                        <v-autocomplete
                            v-model="srg_project_coordinators"
                            :items="srgProjectCoordinators"
                            item-text="name"
                            return-object
                            label="SRG Project Coordinators"
                            :persistent-hint="showPc2TaskRoleHint"
                            :hint="showPc2TaskRoleHint ? pc2TaskRoleHintText : ''"
                            multiple
                            outlined
                            @change="handleProjectCoordinatorSelectionChange"
                            class="mt-4"
                        ></v-autocomplete>
                    </div>

                    <div class="d-block my-6">
                        Enter a project title (optional).<br>
                        <v-text-field
                            v-model="new_project_title"
                            label="Project Title"
                            :maxlength="projectTitleMaxLength"
                            :counter="projectTitleMaxLength"
                            outlined
                            class="mt-3"
                        ></v-text-field>
                    </div>

                    <div class="d-block my-4">
                        <v-switch
                            v-if="showIsAnnualToggle"
                            v-model="new_project_is_annual"
                            label="Is this the start of an Annual project?"
                            inset
                        ></v-switch>
                        <v-switch
                            v-if="showPriorityAccessToggle"
                            v-model="new_project_expedite"
                            label="Should this project have Priority Access?"
                            inset
                        ></v-switch>
                        <v-switch
                            v-model="new_hide_for_user"
                            label="Hide from User's Dashboard"
                            inset
                        ></v-switch>
                    </div>
                </v-card-text>

                <v-card-text v-if="add_module.hasOwnProperty('module_key') && add_module.module_key === 'enterprise-consulting'">
                    <div class="d-block mb-4">
                        Who will be consulting on this project? Please select from the list of SRG consultants below.<br>
                        <v-select
                            v-model="srg_consultants"
                            :items="srgConsultants"
                            item-text="name"
                            return-object
                            label="SRG Consultants"
                            :error="showRequiredFieldErrors && isEnterpriseConsultingSelected && !hasValidConsultantSelection()"
                            :error-messages="showRequiredFieldErrors && isEnterpriseConsultingSelected && !hasValidConsultantSelection() ? ['SRG Consultant is required.'] : []"
                            multiple
                            outlined
                        ></v-select>
                    </div>

                    <div class="d-block mb-2">
                        Enter the project ID of the parent project (if any)<br>
                        <v-text-field
                            v-model="consult_on_project"
                            label="Parent Project ID"
                            outlined
                            class="mt-4"
                        ></v-text-field>
                    </div>

                    <div class="d-block my-6">
                        Enter a project title (optional).<br>
                        <v-text-field
                            v-model="new_project_title"
                            label="Project Title"
                            :maxlength="projectTitleMaxLength"
                            :counter="projectTitleMaxLength"
                            outlined
                            class="mt-4"
                        ></v-text-field>
                    </div>
                </v-card-text>
                
                <!-- <v-divider v-if="add_module.hasOwnProperty('module_key')" class="mx-4"></v-divider> -->

                <v-card-text v-if="add_module.hasOwnProperty('module_key')">
                    <!-- <div class="d-block my-4">
                        <div v-if="!Object.keys(userData).length">Add Primary Owner</div>
                        <div>Add Owners</div>
                        <div>Add Secondary Users</div>
                        <div>Add Partners</div>
                    </div> -->

                    <div v-if="emailTemplateFound" class="mt-3 d-block font-weight-bold d-flex justify-space-between align-center">
                        Email Preview
                        <v-btn 
                            small
                            icon
                            @click="showEmailPreview = !showEmailPreview">
                            <v-icon>{{ showEmailPreview ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                        </v-btn>
                    </div>
                    <div v-if="showEmailPreview && emailTemplateFound" class="mb-1">
                        <v-col cols="12" class="px-1">
                            <EmailPreviewEditor
                                :key="`initiate-email-${add_module.module_key}`"
                                :subject="email_preview.mailSubject || ''"
                                :html="email_preview.mailHtml || ''"
                                @change="emailEdited" />
                        </v-col>
                    </div>
                </v-card-text>

                <v-divider v-if="add_module.hasOwnProperty('module_key')"></v-divider>
                
                <v-card-actions v-if="add_module.hasOwnProperty('module_key')" class="justify-end py-6 px-4">
                    <div class="d-flex mr-4 mt-3">
                        <div class="d-inline mt-n2 mr-1 grey--text text--darken-1">Generate Email(s):</div>
                        <v-checkbox
                            v-model="generate_email_on_add"
                            hide-details
                            color="primary"
                            :disabled="!emailTemplateFound"
                            class="d-inline ma-0 pa-0 mt-n2 mr-n3">
                        </v-checkbox>
                    </div>

                    <v-btn
                        elevation="0"
                        color="primary lighten-2 info--text"
                        @click="addModules">
                        Confirm
                    </v-btn>

                    <v-btn
                        elevation="0"
                        outlined
                        color="primary"
                        @click="handleCancelAddModuleDialogs">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-navigation-drawer>

        <v-btn 
            outlined
            class="light-blue-button"
            color="primary"
            @click="initializeProjectDialog = true">
            <v-icon class="mr-2">mdi-plus</v-icon> New Project
        </v-btn>
    </div>
</template>

<script>
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../../helpers/environment';

    import { srgConsultants, srgProjectManagers, srgProjectCoordinators, srgSalesReps } from '../../helpers/constants'
    import EmailPreviewEditor from './EmailPreviewEditor.vue'
    
    const noProjectCoordinatorOption = {
        name: "None",
        is_none_project_coordinator: true
    }

    const otherSalesRepresentativeOption = {
        name: "Other Salesperson",
        is_other_salesperson: true
    }

    const fallbackOtherSalesRepresentative = srgSalesReps.find(
        (salesRep) => salesRep && salesRep.email === 'nicole.sinclair@successionresourcegroup.com'
    ) || null;

    const flattenConsultants = ( consultants ) => {
        const consultantList = Array.isArray(consultants) ? consultants : [consultants];
        const primaryConsultants = [];
        const secondaryConsultants = [];

        consultantList.forEach(consultant => {
            if (!consultant || typeof consultant !== 'object') return;

            const { sub_team = [], ...parent } = consultant;
            const subTeamMembers = Array.isArray(sub_team) ? sub_team : [];

            primaryConsultants.push(parent);
            subTeamMembers.forEach(member => {
                if (member && typeof member === 'object') {
                    const { sub_team: _nestedSubTeam, ...siblingMember } = member;
                    secondaryConsultants.push(siblingMember);
                }
            });
        });

        return [...primaryConsultants, ...secondaryConsultants];
    }

    export default {
        name: 'addProjectButton',

        components: {
            EmailPreviewEditor
        },
        
        props: {
            userData: Object,
            projects: Array,
            fetchProjectsForType: Function,
            triggerUserFeedback: Function,
        },

        data: () => ({
            initializeProjectDialog: false,
            showSrgConsultantDialog: false,
            showProjectExpertsDialog: false,
            add_module: {},
            showPc2TaskRoleHint: false,
            showIsAnnualToggle: false,
            showPriorityAccessToggle: false,
            showRequiredFieldErrors: false,
            pc2TaskRoleHintText: 'The order makes a difference on which tasks are assigned to whom. The higher level PC should be first and so on. Please refer to the project template for this module to see the default PM/PC/PA assignments and adjust accordingly.',

            all_modules: [],
            assign_modules: [],
            single_module_availability: ['5d357103-3744-4e52-885f-5247d42fa47b'],
 
            generate_email_on_add: true,
            srgConsultants: srgConsultants,
            srg_consultants: [],
            srgProjectManagers: srgProjectManagers,
            srg_project_managers: null,
            srgProjectCoordinators: [noProjectCoordinatorOption, ...srgProjectCoordinators],
            srg_project_coordinators: [],
            srgSalesRepresentatives: [...srgSalesReps, otherSalesRepresentativeOption],
            srg_sales_representatives: [],
            projectTitleMaxLength: 255,
            new_project_is_annual: false,
            new_project_expedite: false,
            new_hide_for_user: false,
            new_project_title: '',
            consult_on_project: '',

            showEmailPreview: false,
            emailTemplateFound: true,
            // Admin edits to the previewed email ({ edited, subject, html }); untouched = send the template
            emailOverride: null,
            email_preview: {
                mailSubject: '',
                mailHtml: '',
                displayDefinitions: {}
            }
        }),

        computed: {
            has_buyer_profile() {
                const projectList = Array.isArray(this.projects) ? this.projects : [];
                return projectList.some((project) => {
                    const moduleKey = String(
                        (project && project.modinfo && project.modinfo.module_key) ||
                        (project && project.module_key) ||
                        ''
                    ).toLowerCase().trim();

                    return moduleKey === 'buyer';
                });
            },

            isEnterpriseConsultingSelected() {
                return !!(
                    this.add_module &&
                    this.add_module.module_key === 'enterprise-consulting'
                );
            },

            availableProjectManagers() {
                return this.srgProjectManagers;
            },

            assignableModules() {
                const modules = Array.isArray(this.all_modules) ? this.all_modules : [];

                return modules
                    .filter(module => module.is_active && !module.is_submodule)
                    .filter(match => !['-starter', '-premium', '-elite'].some(suffix => match.module_key.endsWith(suffix) && match.module_key !== 'deal-support-starter'))
                    .filter(match => !this.has_buyer_profile || match.module_key !== 'buyer');
            }
        },

        watch: {
            add_module: {
                deep: true,
                handler (moduleData) {
                    this.showRequiredFieldErrors = false
                    this.applyModuleTeamDefaults(moduleData)
                    this.updatePc2HintVisibility(moduleData)
                    this.updateIsAnnualToggleVisibility(moduleData)
                    this.isAnnualProjectByDefault(moduleData)
                    this.updatePriorityAccessToggleVisibility(moduleData)
                }
            }
        },
        
        mounted () {
            this.getAllModules()
        },

        methods: {
            getAllModules: async function () {
                try {
                    const all_modules_rs = await axios.get(`${appUrls.api}/api/admin/submodule/false/all_modules`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    })
                
                    if ( all_modules_rs.data.outcome ) {
                        this.all_modules = all_modules_rs.data.modules;
                        for ( let m in this.all_modules ) {
                            this.all_modules[m].module_name_text = this.all_modules[m].module_name
                        }
                    }
                } catch ( error ) {
                    console.log(error);
                }
            },

            getEmailTemplate: async function () {
                this.emailOverride = null

                const moduleKey = this.add_module.module_key || ''
                const emailContentKey = moduleKey === 'buyer' ? 'client_buyer'
                    : moduleKey === 'enterprise-consulting' ? 'initiate_enterprise_consulting'
                    : 'initiate_project'

                // Nothing can be emailed until a template has been found and previewed
                this.setEmailPreview( null )

                try {
                    const get_email_preview = await axios.post(`${appUrls.api}/api/admin/email_preview`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                        params: { 
                            moduleKey: this.add_module.module_key || '',
                            // projectId: null,
                            projectData: {
                                project_title: this.new_project_title || '',
                                is_annual: this.new_project_is_annual,
                                expedite: this.new_project_expedite
                            },
                            userId: this.userData.user_id || '',
                            emailContentKey,
                        }
                    })

                    const email_preview = get_email_preview.data.outcome ? get_email_preview.data.email_preview : null
                    const templateFound = !!(email_preview && email_preview.displayDefinitions && email_preview.displayDefinitions.statusFound)
                    this.setEmailPreview( templateFound ? email_preview : null )
                } catch ( err ) {
                    console.log(err)
                    this.setEmailPreview( null )
                }
            },

            // No template in temailcontent = no preview and no email
            setEmailPreview: function ( email_preview ) {
                this.email_preview = email_preview || { mailSubject: '', mailHtml: '', displayDefinitions: {} }
                this.emailTemplateFound = !!email_preview
                this.generate_email_on_add = !!email_preview
                this.showEmailPreview = !!email_preview
            },

            emailEdited: function ( change ) {
                this.emailOverride = change.edited ? change : null
            },

            handleProjectCoordinatorSelectionChange: function (selectedCoordinators) {
                const selectedList = Array.isArray(selectedCoordinators)
                    ? selectedCoordinators.filter(coordinator => coordinator && typeof coordinator === 'object')
                    : [];

                const hasNoneSelection = selectedList.some(coordinator => coordinator.is_none_project_coordinator);
                if (hasNoneSelection) {
                    this.srg_project_coordinators = [noProjectCoordinatorOption];
                    return;
                }

                const customCoordinators = selectedList.filter(
                    coordinator => !coordinator.is_none_project_coordinator
                );

                if (customCoordinators.length) {
                    this.srg_project_coordinators = customCoordinators;
                    return;
                }

                this.srg_project_coordinators = [noProjectCoordinatorOption];
            },

            getModuleExperts: function (moduleData) {
                const moduleTeam = moduleData && moduleData.srg_team;
                if (moduleTeam && Array.isArray(moduleTeam.experts)) {
                    return moduleTeam.experts.filter(expert => expert && typeof expert === 'object');
                }

                if (Array.isArray(moduleTeam)) {
                    return moduleTeam.filter(expert => expert && typeof expert === 'object');
                }

                return [];
            },

            isAnnualProjectByDefault: function (moduleData) {
                this.new_project_is_annual = !!(moduleData && moduleData.can_annualize && moduleData.annualize_default);
            },

            applyModuleTeamDefaults: function (moduleData) {
                if (!moduleData || typeof moduleData !== 'object' || !moduleData.module_key || this.isEnterpriseConsultingSelected) {
                    this.srg_project_managers = null;
                    this.srg_project_coordinators = [];
                    return;
                }

                const moduleExperts = this.getModuleExperts(moduleData);
                if (!moduleExperts.length) {
                    this.srg_project_managers = null;
                    this.srg_project_coordinators = [noProjectCoordinatorOption];
                    return;
                }

                const managersById = this.srgProjectManagers.reduce((acc, manager) => {
                    if (manager && manager.user_id) {
                        acc[manager.user_id] = manager;
                    }
                    return acc;
                }, {});

                const coordinatorsById = this.srgProjectCoordinators.reduce((acc, coordinator) => {
                    if (coordinator && coordinator.user_id) {
                        acc[coordinator.user_id] = coordinator;
                    }
                    return acc;
                }, {});

                const selectedPm = moduleExperts[0];
                this.srg_project_managers = managersById[selectedPm.user_id] || selectedPm;

                const defaultCoordinators = moduleExperts
                    .slice(1)
                    .filter(member => member && typeof member === 'object' && member.user_id)
                    .map(member => coordinatorsById[member.user_id] || member);

                this.srg_project_coordinators = defaultCoordinators.length
                    ? defaultCoordinators
                    : [noProjectCoordinatorOption];
            },

            handleProjectManagerSelectionChange: function (selectedManager) {
                if (!selectedManager || typeof selectedManager !== 'object') {
                    return;
                }

                if (this.isEnterpriseConsultingSelected) {
                    return;
                }

                const moduleExperts = this.getModuleExperts(this.add_module);

                if (!moduleExperts.length) {
                    return;
                }

                const modulePm = moduleExperts.find(expert => expert && expert.user_id === selectedManager.user_id);
                if (!modulePm) {
                    return;
                }

                const pmSubTeam = Array.isArray(modulePm.sub_team) ? modulePm.sub_team : [];
                if (pmSubTeam.length === 0) {
                    this.srg_project_coordinators = [noProjectCoordinatorOption];
                    return;
                }

                // Preserve PM-defined coordinator order and prefer canonical option references.
                const coordinatorsById = this.srgProjectCoordinators.reduce((acc, coordinator) => {
                    if (coordinator && coordinator.user_id) {
                        acc[coordinator.user_id] = coordinator;
                    }
                    return acc;
                }, {});

                const resolvedSubTeam = pmSubTeam
                    .filter(member => member && typeof member === 'object' && member.user_id)
                    .map(member => coordinatorsById[member.user_id] || member);

                if (resolvedSubTeam.length) {
                    this.srg_project_coordinators = resolvedSubTeam;
                } else {
                    this.srg_project_coordinators = [noProjectCoordinatorOption];
                }
            },

            handleCancelAddModuleDialogs: function () {
                this.add_module = {};
                this.initializeProjectDialog = false;
                this.showSrgConsultantDialog = false;
                this.showProjectExpertsDialog = false;
                this.showRequiredFieldErrors = false;

                this.showPc2TaskRoleHint = false;
                this.showIsAnnualToggle = false;
                this.showPriorityAccessToggle = false;

                this.generate_email_on_add = true;
                this.emailOverride = null;
                this.emailTemplateFound = true;
                this.showEmailPreview = false;
                this.email_preview = {
                    mailSubject: '',
                    mailHtml: '',
                    displayDefinitions: {}
                };

                this.srg_consultants = [];
                this.srg_project_managers = null;
                this.srg_project_coordinators = [];
                this.srg_sales_representatives = [];

                this.consult_on_project = '';
                this.new_project_title = '';
                this.new_project_is_annual = false;
                this.new_project_expedite = false;
                this.new_hide_for_user = false;
            },

            hasValidSalesRepresentativeSelection: function () {
                if (Array.isArray(this.srg_sales_representatives)) {
                    return this.srg_sales_representatives.some(salesRep => salesRep && typeof salesRep === 'object');
                }

                return !!(this.srg_sales_representatives && typeof this.srg_sales_representatives === 'object');
            },

            hasValidProjectManagerSelection: function () {
                return !!(this.srg_project_managers && typeof this.srg_project_managers === 'object');
            },

            hasValidConsultantSelection: function () {
                return Array.isArray(this.srg_consultants) && this.srg_consultants.some(consultant => consultant && typeof consultant === 'object');
            },

            updatePc2HintVisibility: async function (moduleData) {
                const selectedModule = moduleData && typeof moduleData === 'object' ? moduleData : null;
                const moduleId = selectedModule && selectedModule.module_id ? selectedModule.module_id : null;

                if (!moduleId) {
                    this.showPc2TaskRoleHint = false;
                    return;
                }

                try {
                    const projectTemplateResponse = await axios.get(`${appUrls.api}/api/project_template/${moduleId}`, {
                        headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                    });

                    const projectTemplate = projectTemplateResponse && projectTemplateResponse.data && projectTemplateResponse.data.project_template
                        ? projectTemplateResponse.data.project_template
                        : null;

                    const projectSteps = projectTemplate && Array.isArray(projectTemplate.projectSteps)
                        ? projectTemplate.projectSteps
                        : [];

                    this.showPc2TaskRoleHint = projectSteps.some((step) => {
                        const stepTasks = step && Array.isArray(step.tasks) ? step.tasks : [];
                        return stepTasks.some((task) => String(task && task.task_role ? task.task_role : '').toLowerCase().trim() === 'pc2');
                    });
                } catch (error) {
                    this.showPc2TaskRoleHint = false;
                }
            },

            updateIsAnnualToggleVisibility: function (moduleData) {
                const selectedModule = moduleData && typeof moduleData === 'object' ? moduleData : null;
                const isEnterpriseConsultingModule = selectedModule && selectedModule.module_key === 'enterprise-consulting';

                const isAnnualRaw = selectedModule ? selectedModule.can_annualize : false;
                const isAnnual = isAnnualRaw === true || isAnnualRaw === 1 || isAnnualRaw === '1' || isAnnualRaw === 'true';

                this.showIsAnnualToggle = !!selectedModule && !isEnterpriseConsultingModule && isAnnual;

                if (!this.showIsAnnualToggle) {
                    this.new_project_is_annual = false;
                }
            },

            updatePriorityAccessToggleVisibility: function (moduleData) {
                const selectedModule = moduleData && typeof moduleData === 'object' ? moduleData : null;
                const isEnterpriseConsultingModule = selectedModule && selectedModule.module_key === 'enterprise-consulting';

                const canExpediteRaw = selectedModule ? selectedModule.can_expedite : false;
                const canExpedite = canExpediteRaw === true || canExpediteRaw === 1 || canExpediteRaw === '1' || canExpediteRaw === 'true';

                this.showPriorityAccessToggle = !!selectedModule && !isEnterpriseConsultingModule && canExpedite;

                if (!this.showPriorityAccessToggle) {
                    this.new_project_expedite = false;
                }
            },

            addModules: async function () {
                const modulesToAdd = Object.values(this.add_module)
                const isEnterpriseConsultingModule = ['enterprise-consulting'].includes(this.add_module.module_key)
                const usesProjectExpertsDialog = !isEnterpriseConsultingModule

                const selectedSalesRepresentativesRaw = Array.isArray(this.srg_sales_representatives)
                    ? this.srg_sales_representatives.filter(salesRep => salesRep && typeof salesRep === 'object')
                    : (this.srg_sales_representatives && typeof this.srg_sales_representatives === 'object')
                        ? [this.srg_sales_representatives]
                        : [];

                const selectedSalesRepresentativesList = selectedSalesRepresentativesRaw
                    .map((salesRep) => {
                        if (salesRep && salesRep.is_other_salesperson && fallbackOtherSalesRepresentative) {
                            return fallbackOtherSalesRepresentative;
                        }

                        return salesRep;
                    })
                    .filter(salesRep => salesRep && typeof salesRep === 'object');

                const salespersonInfo = selectedSalesRepresentativesList.map(salesRep => ({
                    user_id: salesRep.user_id,
                    user_email: salesRep.user_email || salesRep.email || '',
                    name: salesRep.name || '',
                    title: salesRep.title || ''
                }));

                if ( modulesToAdd.length == 0 ){
                    this.$emit('triggerUserFeedback', true, 'Please select a module to add from the dropdown.', 'accent');
                    return;
                }

                this.showRequiredFieldErrors = true;

                if (!this.hasValidSalesRepresentativeSelection() || (usesProjectExpertsDialog && !this.hasValidProjectManagerSelection()) || (isEnterpriseConsultingModule && !this.hasValidConsultantSelection())) {
                    this.$emit('triggerUserFeedback', true, 'Please complete all required fields before confirming.', 'accent');
                    return;
                }

                try {
                        let consultantsToFlatten = this.srg_consultants;
                        let flattenedConsultants;

                            if (usesProjectExpertsDialog) {
                                const selectedProjectManager = this.srg_project_managers;
                                const hasNoneProjectCoordinatorSelection = this.srg_project_coordinators
                                    .some(coordinator => coordinator && coordinator.is_none_project_coordinator);
                                const selectedProjectCoordinators = this.srg_project_coordinators
                                    .filter(coordinator => coordinator && !coordinator.is_none_project_coordinator)
                                    .map(coordinator => ({
                                        ...coordinator,
                                        is_project_coordinator: true
                                    }));

                                const leadConsultant = selectedProjectManager;
                                const projectCoordinators = hasNoneProjectCoordinatorSelection ? [] : selectedProjectCoordinators;

                                if (leadConsultant) {
                                    consultantsToFlatten = [{
                                        ...leadConsultant,
                                        sub_team: projectCoordinators
                                    }];
                                    flattenedConsultants = flattenConsultants(consultantsToFlatten);
                                } else {
                                    flattenedConsultants = flattenConsultants(projectCoordinators);
                                }
                            } else {
                                flattenedConsultants = flattenConsultants(consultantsToFlatten);
                            }

                            const selectedSalesRepresentatives = selectedSalesRepresentativesList
                                .map(salesRep => ({
                                    ...salesRep,
                                    is_salesperson: true,
                                    user_email: salesRep.user_email || salesRep.email || ''
                                }));

                            if (selectedSalesRepresentatives.length) {
                                const projectConsultants = Array.isArray(flattenedConsultants)
                                    ? flattenedConsultants
                                    : [];

                                flattenedConsultants = [...projectConsultants, ...selectedSalesRepresentatives];
                            }

                            const add_module = await axios.post(`${appUrls.api}/api/admin/add_module`, {
                                headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                                data: {
                                    user_id: this.userData.user_id,
                                    module: this.add_module,
                                    module_id: this.add_module && this.add_module.module_id ? this.add_module.module_id : undefined,
                                    generate_email: this.generate_email_on_add,
                                    email_override: this.generate_email_on_add && this.emailOverride
                                        ? { subject: this.emailOverride.subject, html: this.emailOverride.html }
                                        : undefined,
                                    parent_project_id: '',
                                    project_team: flattenedConsultants,
                                    salesperson_info: salespersonInfo.length ? salespersonInfo : undefined,
                                    projectTitle: this.new_project_title && this.new_project_title.trim() ? this.new_project_title.trim() : undefined,
                                    internalProjectTitle: this.new_project_title && this.new_project_title.trim() ? this.new_project_title.trim() : undefined,
                                    is_annual: (isEnterpriseConsultingModule || !this.showIsAnnualToggle) ? false : this.new_project_is_annual,
                                    expedite: (isEnterpriseConsultingModule || !this.showPriorityAccessToggle) ? false : this.new_project_expedite,
                                    hide_for_user: this.new_hide_for_user
                                }
                            })
                        
                            if ( add_module.data.outcome ) {
                                this.$emit('triggerUserFeedback', true, add_module.data.message);

                                this.initializeProjectDialog = false;
                                this.showSrgConsultantDialog = false;
                                this.showProjectExpertsDialog = false;
                                this.showRequiredFieldErrors = false;
                                this.srg_project_managers = null;
                                this.srg_project_coordinators = [];
                                this.srg_sales_representatives = [];
                                this.new_project_title = '';
                                this.new_project_is_annual = false;
                                this.new_project_expedite = false;
                                this.new_hide_for_user = false;
                                this.$emit('fetchProjectsForType');
                            } else {
                                this.$emit('triggerUserFeedback', true, add_module.data.message, 'accent');

                                this.no_projects = true;
                                this.showSrgConsultantDialog = false;
                                this.showProjectExpertsDialog = false;
                                this.showRequiredFieldErrors = false;
                                this.srg_project_managers = null;
                                this.srg_project_coordinators = [];
                                this.srg_sales_representatives = [];
                                this.new_project_title = '';
                                this.new_project_is_annual = false;
                                this.new_project_expedite = false;
                                this.new_hide_for_user = false;
                            }
                            
                        // RESET THE MODULES ARRAY
                        this.add_module = []
                        this.generate_email_on_add = true;
                        this.emailOverride = null;
                } catch ( error ) {
                    console.log(error);
                }
            }
        }
}
</script>

<style scoped>
    .light-blue-button {
        background-color: #eef7f8;
    }
    .drawer-shadow {
        z-index: 2000;
        position: fixed !important;
        top: 0;
        right: 0;
        left: auto !important;
        height: 100vh !important;
        box-shadow: -6px 0 12px rgba(0, 0, 0, 0.15);
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
        background-color: whitesmoke !important;
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/addProject.vue